<div class="content">
  <form #datenabfrageForm="ngForm">

    <header>
      <div>
      </div>

      <div class="buttons">

        <button (click)="cancel()"
          data-qa="cancel-datenabfrage-button close-details-button"
          matButton="outlined">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button (click)="createNewDatenabfrage()"
          [disabled]="isSaveButtonDisabled()"
          data-qa="sidenav-create-submit-datenabfrage-button"
          matButton="filled">
          <mat-icon>save</mat-icon>
          Datenabfrage erstellen
        </button>

      </div>
    </header>


    <div class="detail-main" data-qa="sidenav-datenabfrage-create-input">

      <fieldset>
        <legend>Informationen zur Abfrage</legend>

        <mat-form-field>
          <mat-label>Bezeichnung</mat-label>
          <input #bezeichnung="ngModel"
            [(ngModel)]="datenabfrage.bezeichnung"
            data-qa="sidenav-create-input-bezeichnungDatenabfrage"
            id="bezeichnungDatenabfrage"
            matInput
            name="bezeichnungDatenabfrage"
            required/>
          @if (bezeichnung?.errors?.required) {
            <mat-error>
              Bitte vergeben Sie eine Bezeichnung
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Abgabefrist</mat-label>
          <input data-qa="sidenav-create-input-abgabefrist" #abgabeFrist="ngModel" [(ngModel)]="datenabfrage.abgabefrist"
            [matDatepicker]="abgabefristDatepicker"
            [min]="tomorrow"
            matInput
            name="abgabefrist"
            required
            >
          <mat-datepicker-toggle [for]="abgabefristDatepicker" matSuffix>
              <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #abgabefristDatepicker></mat-datepicker>
          @if (abgabeFrist?.errors?.required) {
            <mat-error>
              Bitte legen Sie die Abgabefrist fest
            </mat-error>
          }
          @if (abgabeFrist?.errors?.min) {
            <mat-error>
              Die Abgabefrist muss in der Zukunft liegen
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Referenzzeitraum Endverbraucherlast</mat-label>
          <input #referenzzeitraumEndverbraucherlast="ngModel"
            [(ngModel)]="datenabfrage.referenzzeitraumEndverbraucherlast"
            [matDatepicker]="refEndverbraucherLastDatepicker"
            matInput
            name="referenzzeitraumEndverbraucherlast"
            required
            data-qa="sidenav-create-input-referenzzeitraumEndverbraucherlast"
            >
          <mat-datepicker-toggle [for]="refEndverbraucherLastDatepicker" matSuffix>
              <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #refEndverbraucherLastDatepicker></mat-datepicker>
          @if (referenzzeitraumEndverbraucherlast?.errors?.required) {
            <mat-error>
              Bitte legen Sie das Datum Referenzzeitraum für die Endverbraucherlast fest
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Referenzzeitraum Erzeugungsleistung</mat-label>
          <input #referenzzeitraumErzeugerleistung="ngModel"
            [(ngModel)]="datenabfrage.referenzzeitraumErzeugerleistung"
            [matDatepicker]="refErzeugerleistungDatepicker"
            matInput
            name="referenzzeitraumErzeugerleistung"
            required
            data-qa="sidenav-create-input-referenzzeitraumErzeugerleistung"
            >
          <mat-datepicker-toggle [for]="refErzeugerleistungDatepicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #refErzeugerleistungDatepicker></mat-datepicker>
          @if (referenzzeitraumErzeugerleistung?.errors?.required) {
            <mat-error>
              Bitte legen Sie den Referenzzeitraum für die Erzeugerleistung fest
            </mat-error>
          }
        </mat-form-field>

      </fieldset>

    </div>

  </form>
</div>
